import { render, staticRenderFns } from "./DetalhesDescredenciado.vue?vue&type=template&id=d6bc532c&scoped=true"
import script from "./DetalhesDescredenciado.vue?vue&type=script&lang=js"
export * from "./DetalhesDescredenciado.vue?vue&type=script&lang=js"
import style0 from "./DetalhesDescredenciado.vue?vue&type=style&index=0&id=d6bc532c&prod&lang=less"
import style1 from "./DetalhesDescredenciado.vue?vue&type=style&index=1&id=d6bc532c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bc532c",
  null
  
)

export default component.exports